// extracted by mini-css-extract-plugin
module.exports = {"fileThumbnail":"file-thumbnail_fileThumbnail__COciY"};